<div class="placeholder-page-container">
    <h2 *scText="rendering.fields.header"> </h2> <br/>
    <h3>Navigate to sim-result <a href="learn/mobile/byod/compatibility/sim-result">page</a></h3>  
</div>
